import { render, staticRenderFns } from "./AwardAEO.vue?vue&type=template&id=8d1cbeca&scoped=true&"
import script from "./AwardAEO.vue?vue&type=script&lang=js&"
export * from "./AwardAEO.vue?vue&type=script&lang=js&"
import style0 from "./AwardAEO.vue?vue&type=style&index=0&id=8d1cbeca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1cbeca",
  null
  
)

export default component.exports